/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtSetPoolStatus = { pool: Address; status: number };

export type EvtSetPoolStatusArgs = EvtSetPoolStatus;

export function getEvtSetPoolStatusEncoder(): FixedSizeEncoder<EvtSetPoolStatusArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["status", getU8Encoder()],
  ]);
}

export function getEvtSetPoolStatusDecoder(): FixedSizeDecoder<EvtSetPoolStatus> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["status", getU8Decoder()],
  ]);
}

export function getEvtSetPoolStatusCodec(): FixedSizeCodec<
  EvtSetPoolStatusArgs,
  EvtSetPoolStatus
> {
  return combineCodec(
    getEvtSetPoolStatusEncoder(),
    getEvtSetPoolStatusDecoder(),
  );
}
